import DvrOutlinedIcon from "@mui/icons-material/DvrOutlined";
import ForumIcon from "@mui/icons-material/Forum";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import CampaignIcon from "@mui/icons-material/Campaign";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import SchoolIcon from "@mui/icons-material/School";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

import { ReactComponent as IconPublicacao } from "../_assets/icons/wizard/iconPublicacao.svg";

import { returnEnvironment } from "../utils";

const MENU_CONFIG = {
    icons: {
        campanhas: {
            default: DvrOutlinedIcon,
            active: CampaignIcon,
        },
        comunidade: {
            default: ForumOutlinedIcon,
            active: ForumIcon,
        },
        faq: {
            default: SchoolOutlinedIcon,
            active: SchoolIcon,
        },
        learn: {
            default: SchoolOutlinedIcon,
            active: SchoolIcon,
        },
        post: {
            default: IconPublicacao,
            active: IconPublicacao,
        },
        manageCommunity: {
            default: AdminPanelSettingsOutlinedIcon,
            active: AdminPanelSettingsIcon,
        },
        gamification: {
            default: EmojiEventsOutlinedIcon,
            active: EmojiEventsIcon,
        },
        contato: {
            default: ForumOutlinedIcon,
            active: ForumIcon,
        },
        comoFunciona: {
            default: SchoolOutlinedIcon,
            active: SchoolIcon,
        },
    },
    routes: {
        campanhas: {
            default: "/campanhas",
            favela: "/campanhas",
            wizard: "/campanhas/:campaignId",
        },
        comunidade: {
            wizard: "/comunidade/:campaignId",
        },
        faq: {
            default: "/aprenda",
        },
        learn: {
            default: "/aprenda",
        },
        post: {
            wizard: "/novoPost/:campaignId",
        },
        manageCommunity: {
            wizard: "/comunidade/:campaignId/gerenciar/",
        },
        gamification: {
            default: "/gamification",
            wizard: "/gamification",
        },
        comoFunciona: {
            favela: "/como-funciona",
        },
        contato: {
            favela: "/contato",
        },
    },
};

const MENU_STRUCTURE = [
    {
        id: "campanhas",
        title: "Campanhas",
        order: 1,
        environments: ["default", "favela"],
        adminOnly: false,
        showMobile: true,
    },
    {
        id: "comunidade",
        title: "Comunidade",
        order: 2,
        environments: ["wizard"],
        adminOnly: false,
        showMobile: true,
    },
    {
        id: "faq",
        title: "FAQ",
        order: 3,
        environments: ["default"],
        adminOnly: false,
        showMobile: true,
    },
    {
        id: "post",
        title: "Postar",
        order: 2,
        environments: ["wizard"],
        adminOnly: false,
        showMobile: true,
    },
    {
        id: "learn",
        title: "Aprenda",
        order: 3,
        environments: ["wizard"],
        adminOnly: false,
        showMobile: true,
    },
    {
        id: "gamification",
        title: "Gamificação",
        order: 4,
        environments: ["wizard"],
        adminOnly: false,
        showMobile: true,
    },
    {
        id: "manageCommunity",
        title: "Gerenciar Comunidade",
        order: 5,
        environments: ["wizard"],
        adminOnly: true,
        showMobile: false,
    },
    {
        id: 'comoFunciona',
        title: 'Como Funciona?',
        order: 3,
        environments: ['favela'],
        adminOnly: false,
        showMobile: true,
    },
    {
        id: 'contato',
        title: 'Contato',
        order: 4,
        environments: ['favela'],
        adminOnly: false,
        showMobile: true,
    }
];

const buildMenuItem = (item, { creatorIsAdmin, isMobile, comunidade }) => {
    const icons = MENU_CONFIG.icons[item.id] || {};
    const routes = MENU_CONFIG.routes[item.id] || {};
    const currentEnv = returnEnvironment();

    const isAllowedClient = item.environments.includes(currentEnv);
    const matchesAdmin = item.adminOnly ? creatorIsAdmin : true;
    const matchesMobile = isMobile ? item.showMobile !== false : true;

    if (!isAllowedClient || !matchesAdmin || !matchesMobile) {
        return null;
    }

    return {
        title: item.title,
        icon: icons.default || icons.active,
        activeIcon: icons.active || icons.default,
        link: (routes[currentEnv] || routes.default || "").replace(":campaignId", comunidade),
        allowedClients: item.environments.map((env) => ({
            clientType: env,
            order: item.order,
        })),
        adminOnly: item.adminOnly,
        showMobile: item.showMobile,
        mobileOnly: item.mobileOnly,
    };
};

export const buildMenuItems = ({ creatorIsAdmin, isMobile, comunidade }) => {
    const items = MENU_STRUCTURE.map((item) => {
        return buildMenuItem(item, { creatorIsAdmin, isMobile, comunidade });
    })
        .filter(Boolean)
        .sort((a, b) => {
            if (a.adminOnly && !b.adminOnly) return 1;
            if (!a.adminOnly && b.adminOnly) return -1;
            return a.allowedClients[0].order - b.allowedClients[0].order;
        });

    return items;
};
